import { render, staticRenderFns } from "./onlyHeader.vue?vue&type=template&id=7ba8f46a&"
import script from "./onlyHeader.vue?vue&type=script&lang=js&"
export * from "./onlyHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppSideNav: require('/usr/src/app/components/layout/SideNav.vue').default})
